import React from "react";
import "./circularMenu.scss";
import "../../../styles/fontSizes.scss";
import "../../../styles/fontSizes.scss";
import CircularTextOrbit from "../circularTextOrbit/circularTextOrbit";
import ArrowButton from "../../atoms/arrowButton/arrowButton";
import palette from "../../../styles/palette.scss";
import menuImg from "../../../bgImages/home.JPG";
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const CircularMenu = ({ className, textSize, options, setOptionPicked }) => {
  const colors = [
    palette.brown,
    palette.green,
    palette.darkBrown,
    palette.darkGreen,
    palette.brown,
    palette.green,
    palette.darkBrown,
    palette.darkGreen,
  ];
  const initGrades = [0, 45, 90, 135, 180, 225, 270, 315];
  const [grades, setGrades] = React.useState(initGrades);

  const [focus, setFocus] = React.useState(0);
  //[0, 45, 90, 135, 180, 225, 270, 315]
  React.useEffect(() => {
    //Evitar valores muy altos o muy bajos en los grados:
    if (grades[grades.length - 1] < -10000 || grades[grades.length - 1] > 10000)
      setGrades(initGrades);
    if (focus < 0) setFocus(options.length + focus);
  }, [grades]);
  React.useEffect(() => {
    //Evitar valores muy altos o muy bajos en los grados:
    if (focus < 0) setFocus(options.length + focus);
    if (focus >= 0) setOptionPicked(focus);
  }, [focus]);
  const handleClickUp = () => {
    let auxGrades = [...grades];
    auxGrades.forEach((grade, index) => {
      auxGrades[index] = grade + 45;
    });
    setGrades(auxGrades);
    setFocus((focus - 1) % 8);
  };
  const handleClickDown = () => {
    let auxGrades = [...grades];
    auxGrades.forEach((grade, index) => {
      auxGrades[index] = grade - 45;
    });
    setGrades(auxGrades);
    setFocus((focus + 1) % 8);
  };
  return (
    <>
      <div
        className={`${className} circle-menu__container font-size--${textSize}`}
      >
        <ol className={`circle-menu__list`}>
          <img
            className="circle-menu__image"
            src={menuImg}
            alt="Panorámica de la sede La Paz"
          />
          {options.map((item, index) => (
            <CircularTextOrbit
              isOnFocus={focus == index ? true : false}
              bgColor={colors[index]}
              color={palette.white}
              key={index}
              textSize={textSize}
              text={item}
              rotation={grades[index]}
            />
          ))}
        </ol>
        <div className="circle-menu__buttons-container">
          <ArrowButton handleClick={handleClickUp} type={"up"} />
          <ArrowButton handleClick={handleClickDown} type={"down"} />
        </div>
      </div>
    </>
  );
};

export default CircularMenu;
